import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { transparencyService } from './services';

transparencyService();

createRoot(document.getElementById('root') as HTMLElement).render(<App />);
